import insta from "../images/instagram-icon.svg";
import face from "../images/facebook.png";
import linkedin from "../images/linkedin.png";

import { Image, Box, Heading, Flex, List, Link as ChakraLink, Text } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="#000000"
      color="#ffffff"
      borderTop="1px solid"
      borderColor="gray.500"
      py={{ base: "2rem", md: "2.5rem" }}
      fontSize={{ base: "1rem", md: "1.1rem" }}
      fontFamily="'Times New Roman', serif"
    >
      {/* Main Footer Content */}
      <Box
        maxW="88%"
        mx="auto"
        pb="2rem"
        mb="1.5rem"
        px={{ base: "1rem", md: "2rem", lg: "5rem" }}
        borderBottom="1px solid"
        borderColor="gray.500"
      >
        <Flex
          flexWrap="wrap"
          alignItems="start"
          justifyContent="space-between"
          flexDirection={{
            base: "column",
            md: "row",
            lg: "row",
          }}
          rowGap={{ base: "1.5rem", md: "2rem" }}
        >
          {/* GYAN Section */}
          <Box
            flex={{ base: "1", md: "1.5" }}
            minW="300px"
            textAlign="left"
            mb={{ base: "1.5rem", md: "0" }}
          >
            <Text fontSize="2rem" fontWeight="bold">GYAN</Text>
            <Text fontSize="1.2rem" fontWeight="bold" fontStyle="italic">
              By AiM4u Software Solutions
            </Text>
            <Text mt="0.8rem" fontWeight="bold" fontSize="1.2rem">
              Skills-based Internships Programs
            </Text>
          </Box>

          {/* Sections: Explore, Contact & Legal */}
          <Flex
            flexWrap="nowrap"
            alignItems="start"
            justifyContent="space-between"
            flexDirection={{
              base: "row",
              md: "row",
              lg: "row",
            }}
            rowGap={{ base: "1.5rem", md: "2rem" }}
            sx={{
              "@media (max-width: 645px)": {
                flexWrap: "wrap",
                flexDirection: "column",
              },
            }}
          >
            <Box minW="200px" textAlign="left">
              <Heading as="h5" mb="0.5rem" fontSize="1.7rem" fontWeight="600" fontFamily="'Times New Roman', serif">
                Explore
              </Heading>
              <List lineHeight="2">
                <Text _hover={{ color: "#3F67F6" }}>
                  <ChakraLink href="/">Home</ChakraLink>
                </Text>
                <Text _hover={{ color: "#3F67F6" }}>
                  <ChakraLink href="/about">About</ChakraLink>
                </Text>
                <Text _hover={{ color: "#3F67F6" }}>
                  <ChakraLink href="/internship">Internship</ChakraLink>
                </Text>
                <Text _hover={{ color: "#3F67F6" }}>
                  <ChakraLink href="/faq">FAQs</ChakraLink>
                </Text>
              </List>
            </Box>

            <Box minW="250px" textAlign="left">
              <Heading as="h5" mb="0.5rem" fontSize="1.7rem" fontWeight="600" fontFamily="'Times New Roman', serif">
                Contact
              </Heading>
              <List lineHeight="1.4">
                <Text>AiM4u Software Solutions</Text>
                <Text>Private Limited, 8th Floor,</Text>
                <Text>SP-TBI Munshi Nagar,</Text>
                <Text>Andheri(W), Mumbai-400058</Text>
                <Text mt="0.4rem">+91 8657424574</Text>
                <Text _hover={{ color: "#3F67F6" }}>
                  support@aim4u.co.in
                </Text>
              </List>
            </Box>

            <Box minW="200px" textAlign="left">
              <Heading as="h5" mb="0.5rem" fontSize="1.7rem" fontWeight="600" fontFamily="'Times New Roman', serif">
                Legal
              </Heading>
              <List lineHeight="2">
                <Text _hover={{ color: "#3F67F6" }}>
                  <ChakraLink href="https://www.aim4u.co.in/#/terms-and-conditions">
                    Terms & Conditions
                  </ChakraLink>
                </Text>
                <Text _hover={{ color: "#3F67F6" }}>
                  <ChakraLink href="https://www.aim4u.co.in/#/privacy-policy">
                    Privacy Policy
                  </ChakraLink>
                </Text>
                <Text _hover={{ color: "#3F67F6" }}>
                  <ChakraLink href="https://aim4u.co.in/#/refund">
                    Refund Policy
                  </ChakraLink>
                </Text>
              </List>
            </Box>
          </Flex>
        </Flex>
      </Box>

      {/* Social Media & Copyright */}
      <Flex
        maxW="85%"
        mx="auto"
        px={{ base: "1rem", md: "3rem", lg: "5rem" }}
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        flexDirection={{
          base: "column",
          md: "row",
        }}
        fontWeight="extrabold"
        rowGap={{ base: "1rem", md: "0" }}
      >
        <Flex
          gap="1.5rem"
          alignItems="center"
          flexWrap="wrap"
          justifyContent={{ base: "center", md: "start" }}
        >
          <Text fontSize="1.2rem">Follow Us:</Text>
          <ChakraLink href="https://www.facebook.com/aim4usoftwaresolutions/">
            <Image boxSize="30px" src={face} title="Facebook" />
          </ChakraLink>
          <ChakraLink href="https://www.instagram.com/aim4u.co.in/">
            <Image boxSize="30px" src={insta} title="Instagram" />
          </ChakraLink>
          <ChakraLink href="https://www.linkedin.com/company/aim4u-software-solution/">
            <Image boxSize="30px" src={linkedin} title="LinkedIn" />
          </ChakraLink>
        </Flex>

        <Text
          fontSize="1rem"
          textAlign={{ base: "center", md: "right" }}
          mt={{ base: "1.2rem", md: "0" }}
        >
          Copyright &copy; All Rights Reserved 2023-25 by{" "}
          <ChakraLink
            href="https://aim4u.co.in/#/"
            color="#3F67F6"
            _hover={{ textDecoration: "underline" }}
            isExternal
          >
            AiM4u Software Solutions
          </ChakraLink>
        </Text>
      </Flex>
    </Box>
  );
};

export default Footer;
